import * as React from 'react';

const CreatePage = () => {
  return <div>create page</div>;
};

export default CreatePage;
